const BIRTH_MONTHS = [
	"Janeiro",
	"Fevereiro",
	"Março",
	"Abril",
	"Maio",
	"Junho",
	"Julho",
	"Agosto",
	"Setembro",
	"Outubro",
	"Novembro",
	"Dezembro",
];

const SELECT_CLASS = "control-field rounded-xl border-2 px-4 py-4 text-xl";

function splitDate(value: string): [string, string, string] {
	const parts = value.split("/");

	return [parts[0] ?? "", parts[1] ?? "", parts[2] ?? ""];
}

export function DateStep({ value, onChange }: { value: string; onChange: (v: string) => void }) {
	const [day, month, year] = splitDate(value);

	const apply = (nd: string, nm: string, ny: string) => {
		const anyFilled = nd !== "" || nm !== "" || ny !== "";

		if (!anyFilled) {
			onChange("");
			return;
		}

		onChange(`${nd}/${nm}/${ny}`);
	};

	return (
		<div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
			<input
				value={day}
				inputMode="numeric"
				maxLength={2}
				placeholder="Dia"
				onChange={(e) => apply(e.target.value.replaceAll(/\D/gu, "").slice(0, 2), month, year)}
				onBlur={() => apply(day === "" ? "" : day.padStart(2, "0"), month, year)}
				className={`${SELECT_CLASS} w-full sm:w-24 placeholder:text-foreground/40`}
			/>

			<select
				value={month}
				onChange={(e) => apply(day, e.target.value, year)}
				className={`${SELECT_CLASS} w-full sm:flex-1`}
			>
				<option value="">Mês</option>
				{BIRTH_MONTHS.map((label, i) => {
					const option = String(i + 1).padStart(2, "0");

					return (
						<option key={option} value={option}>
							{label}
						</option>
					);
				})}
			</select>

			<input
				value={year}
				inputMode="numeric"
				maxLength={4}
				placeholder="Ano"
				onChange={(e) => apply(day, month, e.target.value.replaceAll(/\D/gu, "").slice(0, 4))}
				className={`${SELECT_CLASS} w-full sm:w-32 placeholder:text-foreground/40`}
			/>
		</div>
	);
}
